import { Component } from '@angular/core';

@Component({
  selector: 'app-admission-enquiry-thankyou',
  templateUrl: './admission-enquiry-thankyou.component.html',
  styleUrls: ['./admission-enquiry-thankyou.component.css']
})
export class AdmissionEnquiryThankyouComponent {

}
